module.exports = __webpack_public_path__ + "img/micro.a10c753a.png";